import pubSub from './utils/pubSub';

export default (stores) => {
  const { employeeStore, planStore } = stores;

  pubSub.subscribe('fetch:employees', (eventName, date) => {
    employeeStore.fetchEmployees(typeof date !== 'undefined' ? date : false);
  });

  pubSub.subscribe('fetch:day', (e, date) => {
    planStore.refreshPlanningForDay(date);
  });
};



// WEBPACK FOOTER //
// ./src/eventListeners.js